import React from 'react';

const DebitCardIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5 5.66279C16.5 6.15779 16.095 6.56279 15.6 6.56279H2.4C1.905 6.56279 1.5 6.15779 1.5 5.66279V5.65529C1.5 3.93779 2.8875 2.55029 4.605 2.55029H13.3875C15.105 2.55029 16.5 3.94529 16.5 5.66279Z"
        fill="#191919"
      />
      <path
        d="M1.5 8.5875V12.345C1.5 14.0625 2.8875 15.45 4.605 15.45H13.3875C15.105 15.45 16.5 14.055 16.5 12.3375V8.5875C16.5 8.0925 16.095 7.6875 15.6 7.6875H2.4C1.905 7.6875 1.5 8.0925 1.5 8.5875ZM6 12.9375H4.5C4.1925 12.9375 3.9375 12.6825 3.9375 12.375C3.9375 12.0675 4.1925 11.8125 4.5 11.8125H6C6.3075 11.8125 6.5625 12.0675 6.5625 12.375C6.5625 12.6825 6.3075 12.9375 6 12.9375ZM10.875 12.9375H7.875C7.5675 12.9375 7.3125 12.6825 7.3125 12.375C7.3125 12.0675 7.5675 11.8125 7.875 11.8125H10.875C11.1825 11.8125 11.4375 12.0675 11.4375 12.375C11.4375 12.6825 11.1825 12.9375 10.875 12.9375Z"
        fill="#191919"
      />
    </svg>
  );
};

export default DebitCardIcon;
